import {Component, OnInit, Renderer2} from '@angular/core';
import {combineLatest, map, Observable} from "rxjs";
import {CookieService, CookieStatus} from "../../services/cookie.service";
import {ApplicationService} from "../../services/application.service";
import alltranslations from './translations/translations.json';
import {environment} from "../../../../environments/environment";
import {SsoService} from "../../services/sso.service";
import {AuthenticationService} from "../../services/authentication.service";

interface Translation {
  lang: string;
  Title: string;
  Message: string;
  BtnAccept: string;
  BtnReject: string;
  Manage: string;
  AnalyticCookies: string;
  CookiePolicy: string;
  CookieConsent: string;
}

@Component({
  selector: 'app-cookie-consent',
  templateUrl: './cookie-consent.component.html',
  styleUrls: ['./cookie-consent.component.scss']
})
export class CookieConsentComponent implements OnInit {
  isCookiePolicyEvaluated: boolean = false;
  translations: Translation | undefined;

  constructor(private cookieService: CookieService, private renderer: Renderer2, private applicationService: ApplicationService,
              private sso: SsoService, private auth: AuthenticationService) {}

  ngOnInit(): void {

    if(environment.cookiesenabled) {
      this.loadTranslations();
      this.renderer.addClass(document.body, 'disable-focus');
      this.cookieService.cookiePolicySubject.subscribe(value => {
        if(document.location.href.includes("password-reset"))
           {

             this.isCookiePolicyEvaluated = true;
        }
        else {
          this.isCookiePolicyEvaluated = value != CookieStatus.NOT_EVALUATED
        }

      });

    }
    else {
      this.isCookiePolicyEvaluated = true;
    }
  }


  loadTranslations(): void {
    const currentLanguage = this.applicationService.getCurrentLanguage() || 'en-Gb';
    this.translations = alltranslations.data.find(translation => {
      return translation.lang === currentLanguage;
    });
    if (this.translations?.Message && this.translations?.CookiePolicy) {
      const policyText = this.translations.CookiePolicy;
      this.translations.Message = this.translations.Message.replace(
        policyText,
        `<a href="${this.getLink()}" target="_blank">${policyText}</a>`
      );
    }
  }

  getLink(): string {
    return `/assets/policy/policy.html?lang=${this.applicationService.getCurrentLanguage()}`;
  }

  acceptCookies(): void {
    this.cookieService.cookiePolicySubject.next(CookieStatus.ACCEPTED);
    this.renderer.removeClass(document.body, 'disable-focus');
    this.isCookiePolicyEvaluated = true;
  }

  rejectCookies(): void {
    this.cookieService.cookiePolicySubject.next(CookieStatus.REJECTED);
    this.isCookiePolicyEvaluated = true;
  }
}
